import { render, staticRenderFns } from "./SetupTip.vue?vue&type=template&id=24ba7388&scoped=true&"
import script from "./SetupTip.vue?vue&type=script&lang=js&"
export * from "./SetupTip.vue?vue&type=script&lang=js&"
import style0 from "./SetupTip.vue?vue&type=style&index=0&id=24ba7388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba7388",
  null
  
)

export default component.exports